import React, { useContext } from "react";
import { Menu, Image, Drawer, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import dashboardIcon from "../../../assets/images/menuImages/dashboard.svg";
import homeActive from "../../../assets/images/menuImages/homeActive.svg";
import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { getRoleLabelWithFacility } from "../../../helpers/getRoleLabel";
import { Role } from "../../../constants/defaultKeys";
import diet from "../../../assets/images/patientIcons/DietImg.svg";
import activeDiet from "../../../assets/images/patientIcons/DietImgActive.svg";
import MG from "../../../assets/images/patientIcons/MANAGE Appointments.svg";
import MGActive from "../../../assets/images/patientIcons/MANAGE Appointments Active.svg";
import exercise from "../../../assets/images/patientIcons/EXERCISE.svg";
import activeExercise from "../../../assets/images/patientIcons/EXERCISEActive.svg";
import { redirectToDashboard } from "../../../helpers/auth/helper";
import MobileUserSettingsPanel from "../CustomLayout/MobileUserSettingsPanel";
import useIsMobile from "../../../hooks/useIsMobile";
import "./DoctorLayout.css";

const DocSideMenu = ({
  collapsed,
  open,
  setOpen,
  activeRoleObj,
  onRoleChange,
  hideNavMenu = false,
}) => {
  const { userDetails } = useContext(UserContext);
  const router = useParams();
  const navigate = useNavigate();
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const role = defaultRole.toLowerCase().replaceAll("_", "-");
  const showRoleSelect = userDetails?.activeOrg?.roles?.length > 1;
  const isMobile = useIsMobile();

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const menuImages = (icon) => {
    return (
      <span
        role="img"
        aria-label="icon"
        className="anticon anticon-user ant-menu-item-icon"
      >
        <Image
          src={icon}
          preview={false}
          style={{ height: "20px", width: "auto", marginBottom: "8px" }}
        />
      </span>
    );
  };

  const items = [
    getItem(
      "Home",
      "home",
      router?.tab === "home"
        ? menuImages(homeActive)
        : menuImages(dashboardIcon)
    ),
    getItem(
      "Manage Appointments",
      "appointments",
      router?.tab === "appointments"
        ? menuImages(MGActive)
        : menuImages(MG)
    ),
    getItem(
      "Diet Chart",
      "diet-chart",
      router?.tab === "diet-chart" ? menuImages(activeDiet) : menuImages(diet)
    ),
    getItem(
      "Exercise",
      "exercise",
      router?.tab === "exercise"
        ? menuImages(activeExercise)
        : menuImages(exercise)
    ),
  ];

  const onClick = (e) => {
    setOpen(false);
    if (e.key === "home") {
      redirectToDashboard(
        userDetails?.activeOrg?.domain,
        defaultRole,
        activeRoleObj
      );
    } else if (e.key === "appointments") {
      navigate(`/${role}/appointments?agenda=myAppointments`);
    } else if (e.key === "diet-chart") {
      navigate(`/${role}/diet-chart`);
    } else if (e.key === "exercise") {
      navigate(`/${role}/exercise`);
    } else {
      navigate(`/${role}/${e.key}`);
    }
  };

  return (
    <Drawer
      placement="left"
      closable={!isMobile}
      onClose={() => setOpen(false)}
      open={open}
      width={isMobile ? "100%" : 250}
      rootClassName={
        isMobile ? "reception-mobile-drawer-fullscreen" : "doctor-desktop-drawer"
      }
      styles={{
        body: isMobile
          ? {
              display: "flex",
              flexDirection: "column",
              height: "100%",
              padding: "16px",
              paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
            }
          : {
              padding: "16px",
            },
      }}
    >
      {isMobile && (
        <div className="reception-mobile-drawer-header">
          {showRoleSelect ? (
            <Select
              className="reception-mobile-drawer-select"
              value={`${userDetails?.currRole}_${userDetails?.currFacility}`}
              onChange={(value) => {
                onRoleChange(value);
                setOpen(false);
              }}
            >
              {userDetails?.activeOrg?.roles?.map(
                (roleItem) =>
                  roleItem.role !== "Partner" && (
                    <Select.Option
                      key={`${roleItem.role}_${roleItem.facility_id}`}
                      value={`${roleItem.role}_${roleItem.facility_id}`}
                    >
                      {getRoleLabelWithFacility(roleItem)}
                    </Select.Option>
                  )
              )}
            </Select>
          ) : (
            <span className="reception-mobile-drawer-header-spacer" />
          )}
          <button
            type="button"
            className="reception-mobile-drawer-close"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            <CloseOutlined />
          </button>
        </div>
      )}

      {!hideNavMenu && (
        <div className={isMobile ? "reception-mobile-drawer-menu" : undefined}>
          <Menu
            style={{ border: 0 }}
            onClick={onClick}
            selectedKeys={[router?.tab]}
            defaultSelectedKeys={[router?.tab]}
            inlineCollapsed={collapsed}
            items={items}
          />
        </div>
      )}

      {isMobile && (
        <div className="mobile-only reception-mobile-drawer-footer">
          <MobileUserSettingsPanel onNavigate={() => setOpen(false)} />
        </div>
      )}
    </Drawer>
  );
};

export default DocSideMenu;
